import {
  API,
  BASE,
  I18N,
  ME,
  ROUTES,
  SIDEBAR_LINKS,
  URL_USERS,
  V1,
  apiClient,
  cn,
  removeTokenCookies,
  useBreakpoints,
} from '@jobcost-monorepo/utils';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import UserMenu from '../UserMenu';
import { IUser } from '@jobcost-monorepo/crud';
import Cookies from 'js-cookie';
import { useState, useEffect } from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';

interface Props {
  setSidebarOpen: (value: boolean) => void;
}

const Navbar = ({ setSidebarOpen }: Props) => {
  const { t } = useTranslation('sidebar');
  const location = useLocation();
  const path = location.pathname.split('/')[1];
  const { isSmall } = useBreakpoints();
  const [user, setUser] = useState<IUser | null>(null);
  const navigate = useNavigate();
  const lang = 'it';
  const isAdmin = user?.role === 'ADMIN';

  const getTabName = (): string => {
    for (const link of SIDEBAR_LINKS) {
      if (link.navigateTo === path) {
        return link.label;
      }
      if (link.subList) {
        for (const subLink of link.subList) {
          if (subLink.navigateTo === path) {
            return subLink.label;
          }
        }
      }
    }
    return '';
  };

  const handleLogout = () => {
    removeTokenCookies();
    return navigate(ROUTES.SIGN_IN);
  };

  const loadUser = async () => {
    const { data } = await apiClient.get<IUser>({
      url: `${BASE}${API}${V1}${URL_USERS}${ME}`,
    });

    if (data?.email) {
      setUser(data);
      if (data.hasDarkTheme) {
        document.documentElement.classList.add('dark');
      }
      lang && Cookies.set(I18N, lang.split('-')[0]);
      return;
    }

    navigate(`/${ROUTES.SIGN_IN}`);
    removeTokenCookies();
  };

  useEffect(() => {
    void loadUser();
  }, []);

  return (
    <div className="flex h-[55px] justify-between shadow-lg shadow-purple30 dark:shadow-extraDark30 rounded-br-3xl">
      <div
        className={cn(
          'h-full flex items-center bg-gradient-to-r from-pink via-purple to-white dark:to-dark',
          isSmall ? 'w-[80%]' : 'w-[50%]',
        )}
      >
        {isSmall && isAdmin && (
          <button
            type="button"
            className="p-2.5 text-gray-700 lg:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <Bars3Icon
              className="h-6 w-6 fill-white stroke-white"
              aria-hidden="true"
            />
          </button>
        )}
        <p className="text-2xl text-white pl-6">{t(getTabName())}</p>
      </div>

      <div className="mr-4 content-center">
        <UserMenu user={user} onClickLogout={handleLogout} />
      </div>
    </div>
  );
};

export default Navbar;
